(() => {
  const assetBase = window.kikanboAssetBase || "";
  const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const normalizedRoot = rootUrl.endsWith("/") ? rootUrl : `${rootUrl}/`;
  const pageWrapper = document.querySelector(".kikanbo-page");
  const lang = pageWrapper ? pageWrapper.getAttribute("data-kikanbo-lang") : "ja";

  const jaMap = {
    "": "__root__",
    "index.html": "__root__",
    "about": "about",
    "menu": "menu",
    "shop": "shop",
    "recruit": "recruit",
    "recruit/entry": "recruit-entry",
    "contact": "contact",
    "company": "company",
    "category/info": "news",
    "newsarticle.html": "newsarticle",
    "privacy": "privacy",
    "information": "information",
    "information": "information",
    "shopping": "shopping",
    "shopping/products": "shopping-products",
    "english/franchise": "english-franchise",
    "english/franchise/partner": "english-franchise-partner",
  };

  const enMap = {
    "": "english",
    "index.html": "english",
    "about": "english-about",
    "menu": "english-menu",
    "shop": "english-shop",
    "recruit": "english-recruit",
    "recruit/entry": "english-recruit-entry",
    "contact": "english-contact",
    "company": "english-company",
    "category/info": "english-news",
    "franchise": "english-franchise",
    "franchise/partner": "english-franchise-partner",
    "privacy": "english-privacy",
    "shopping": "shopping",
  };

  const pageMap = lang === "en" ? enMap : jaMap;

  const normalizePath = (path) => {
    if (!path) return "";
    let normalized = path.replace(/^(\.\.\/)+/, "").replace(/^\.\//, "");
    normalized = normalized.replace(/\/index\.html$/, "").replace(/index\.html$/, "");
    if (normalized.endsWith("/")) {
      normalized = normalized.slice(0, -1);
    }
    return normalized;
  };

  const getTargetUrl = (rawHref) => {
    if (!rawHref || rawHref.startsWith("#")) return null;
    if (/^(https?:|mailto:|tel:)/i.test(rawHref)) return null;
    const [pathPart, hashPart] = rawHref.split("#");
    const normalized = normalizePath(pathPart);
    if (!(normalized in pageMap)) return null;
    const target = pageMap[normalized];
    const anchor = hashPart ? `#${hashPart}` : "";
    if (target === "__root__") {
      return `${normalizedRoot}${anchor}`;
    }
    return `${normalizedRoot}pages/${target}${anchor}`;
  };

  document.querySelectorAll("a[href]").forEach((link) => {
    const newHref = getTargetUrl(link.getAttribute("href"));
    if (newHref) {
      link.setAttribute("href", newHref);
    }
  });

  const updateSrc = (value) => {
    if (!value) return value;
    if (/^(https?:|data:|blob:)/i.test(value)) return value;
    const cleaned = value.replace(/^(\.\.\/)+/, "").replace(/^\.\//, "");
    if (!cleaned.startsWith("images/")) return value;
    const assetPath = cleaned.replace(/^images\//, "");
    return `${assetBase}images/${assetPath}`;
  };

  document.querySelectorAll("img[src]").forEach((img) => {
    img.setAttribute("src", updateSrc(img.getAttribute("src")));
  });

  document.querySelectorAll("source[srcset]").forEach((source) => {
    const srcset = source.getAttribute("srcset");
    if (!srcset) return;
    const updated = srcset
      .split(",")
      .map((entry) => {
        const [url, size] = entry.trim().split(/\s+/, 2);
        const nextUrl = updateSrc(url);
        return size ? `${nextUrl} ${size}` : nextUrl;
      })
      .join(", ");
    source.setAttribute("srcset", updated);
  });
})();
